<template>
    <div>
        <div class="banner-wrap">
            <div class="banner">
                <div class="container">
                    <h2>Günstiger Top-Schutz für Fahrrad oder E-Bike</h2>
                    <ul>
                        <li>Weltweiter Diebstahlschutz (24/7)</li>
                        <li>Erstattung von Reparaturkosten</li>
                        <li>Optional: Schutzbrief</li>
                    </ul>
                </div>
            </div>
            <div class="gradient-overlay"></div>
        </div>
        <div class="container">
            <div class="row" v-if="!botReady">
                <div class="col-md-6">
                    <h3>Prämie berechnen</h3>
                    <form>
                        <label>Postleitzahl</label>
                        <input type="text" class="form-control" maxlength="5" placeholder="Zum Beispiel: 10243" v-model="fields.zipcode" @input="validateZipcode()" :class="{error: zipError, valid: zipValid}" required />
                        <label>Fahrradart</label>
                        <div class="row">
                            <div class="col">
                                <label class="radio-container">
                                    <input type="radio" value="Fahrrad" name="radio" v-model="fields.bikeType" id="normal" class="custom-radio">
                                    <label for="normal">Fahrrad</label>
                                </label>
                                <label class="radio-container">
                                    <input type="radio" value="E-Bike" name="radio" v-model="fields.bikeType" class="custom-radio" id="ebike">
                                    <label for="ebike">E-Bike / Pedelec</label>
                                </label>
                            </div>
                        </div>
                        <label>Neukaufpreis</label>
                        <input type="text" class="form-control" placeholder="Neukaufpreis des Fahrrads in Euro" v-model="fields.price" :class="{error: priceError, valid: priceValid}" @input="validatePrice()" required />
                        <span class="pre-submit">Versichere dein Fahrrad jetzt ab 3,84 Euro im Monat.</span>
                        <span class="submit" @click="toBotPage()">Beitrag berechnen<span class="janina"></span></span>
                    </form>
                </div>
                <div class="col-md-6">
                    <div class="statistics">
                        <h3>Großstädte mit den meisten Fahrraddiebstählen im Jahr 2021*</h3>
                        <div class="statistics-wrapper">
                            <iframe src="https://www.google.com/maps/d/embed?mid=1_xwSndp2MUvgx-wK2e480fmFchYljbg&ehbc=2E312F&z=6&spn=0.006294,0.009645&hl=de"></iframe>
                        </div>
                        <p style="font-size: 10px; margin-top: -75px; position: relative; z-index: 11;">*Quelle: <a style="color: #212529; text-decoration: none;" href="https://de.statista.com/statistik/daten/studie/570624/umfrage/fahrraddiebstaehle-und-aufgeklaerte-faelle-in-deutschen-staedten" target="blank">https://de.statista.com/statistik/daten/studie/570624/umfrage/fahrraddiebstaehle-und-aufgeklaerte-faelle-in-deutschen-staedten</a></p>
                    </div>
                </div>
            </div>
            <Bot :fields="fields" v-if="botReady" />
        </div>
        <div class="data-protect" v-if="dataProtect">
            <div class="box">
                <p>Ich habe die <a href="https://www.janitos.de/datenschutz/" target="_blank">Hinweise zum Datenschutz</a> gelesen und erkläre mich damit einverstanden, dass meine personenbezogenen Daten im Sinne der EU-Datenschutzgrundverordnung zur Bearbeitung und Beantwortung meiner Anfrage durch die Janitos Versicherung AG erhoben, übermittelt, verarbeitet und genutzt werden.</p>
                <span class="submit" @click="dataProtectAgree()">Einverstanden</span>
            </div>
        </div>
    </div>
</template>

<script>
import Bot from '@/components/Bot.vue';

export default {
    components: {
        Bot
    },
    data() {
        return {
            profile: {},
            fields: {
                zipcode: '',
                bikeType: 'Fahrrad',
                price: null
            },
            zipError: false,
            zipValid: false,
            priceError: false,
            priceValid: false,
            botReady: false,
            dataProtect: false
        }
    },
    created() {
        if (localStorage.getItem('ja-dataProtect') === null) {
            this.dataProtect = true;
            document.querySelector('body').classList.add('modal-open');
        }
    },
    methods: {
        dataProtectAgree() {
            document.querySelector('body').classList.remove('modal-open');
            localStorage.setItem('ja-dataProtect', true);
            this.dataProtect = false;
        },
        validateZipcode() {
            let zipRegex = /(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})/g;
            let result = zipRegex.test(this.fields.zipcode);
            if (result) {
                this.zipError = false;
                this.zipValid = true;
            }
            else {
                this.zipError = true;
                this.zipValid = false;
            }
        },
        validatePrice() {
            this.fields.price = this.fields.price.replace('-', '');
            if (this.fields.price.charAt(0) === '0') {
                this.fields.price = '';
            }
            if (this.fields.price.includes(',')) {
                this.fields.price = this.fields.price.replace(',', '');
            }
            if (this.fields.price.includes('.')) {
                this.fields.price = this.fields.price.replace('.', '');
            }
            let nan = false;
            if (isNaN(this.fields.price) && this.fields.price.length < 1) {
                nan = true;
                this.priceError = true;
                this.priceValid = false;
            }
            if (this.fields.price.length > 1 && !nan && this.fields.price.length > 1) {
                this.priceError = false;
                this.priceValid = true;
            }
            else {
                this.priceError = true;
                this.priceValid = false;
            }
        },
        toBotPage() {
            if (!this.fields.zipcode.length) {
                this.zipError = true;
            }
            if (!this.fields.price.length) {
                this.priceError = true;
            }
            if (this.zipValid && this.priceValid) {
                this.botReady = true;
                this.fields.price = this.fields.price.replace(',','.');
            }
        }
    }
}
</script>
